export default "__VITE_ASSET__UI$8kCjn__"